import React from "react";
import ReactModal from "react-modal";
import "./add-member-modal.scss";
import { Formik } from "formik";
import { Card, Col, Form } from "react-bootstrap";
import * as yup from "yup";
import Cleave from "cleave.js/react";
import SelectDropDown from "../../shared/drop-down/drop-down";
import {
    AddMemberToOrganization,
    UpdateMember,
    emsOffices,
} from "../../../api";
import Select from "react-select";
import config from "../../../config";
import { UserChannel } from "./partial/UserChannel";
import { Team } from "./partial/Team";
const schema = yup.object({
    first_name: yup.string().trim().required("* First Name is required"),
    last_name: yup.string().trim().required("* Last Name is required"),

    email: yup.string().required("* Email required"),
    role: yup.string().required("* Role required"),
});

const host_signing_options = [
    { label: "Please Select", value: "" },
    { label: "Yes", value: 1 },
    { label: "No", value: 0 },
];
const ems_entity_options = [
    { label: "PC", value: "pc" },
    { label: "EMS", value: "ems" },
    { label: "PaymentNerds", value: "paymentnerds" },
    { label: "Paychex", value: "paychex" },
];
const is_v2_enable_options = [
    { label: "Please Select", value: "" },
    { label: "Yes", value: 1 },
    { label: "No", value: 0 },
];

class AddMembermodal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isEdit: props.selectedMember ? true : false,
            is_submitted: false,
            addMemberOptions: [
                { value: "agent", label: "Agent" },
                { value: "admin", label: "Admin" },
                // commented out till sorted
                // { "value": "office_head", "label": "Office Head" },
                // { "value": "branch_head", "label": "Branch Head" }
            ],
            formData: {
                first_name: props.selectedMember
                    ? props.selectedMember.name.split(" ")[0]
                    : "",
                last_name: props.selectedMember
                    ? props.selectedMember.name.split(" ")[1]
                    : "",
                email: props.selectedMember ? props.selectedMember.email : "",
                role: props.selectedMember ? props.selectedMember.role : "",
                office_id: props.selectedMember
                    ? props.selectedMember.office_id
                    : "",
                branch_id: props.selectedMember
                    ? props.selectedMember.branch_id
                    : "",

                allowed_offices: props.selectedMember
                    ? props.selectedMember.allowed_offices
                    : "",
                allowed_branches: props.selectedMember
                    ? props.selectedMember.allowed_branches
                    : "",


                phone_direct: props.selectedMember
                    ? props.selectedMember.phone_direct
                    : "",
                phone_cell: props.selectedMember
                    ? props.selectedMember.phone_cell
                    : "",
                address: props.selectedMember
                    ? props.selectedMember.address
                    : "",
                zoho_user_id: props.selectedMember
                    ? props.selectedMember.zoho_user_id
                    : "",
                is_view_residual: props.selectedMember
                    ? props.selectedMember.is_view_residual
                    : false,
                is_override: props.selectedMember
                    ? props.selectedMember.is_override
                    : false,
                override_department_id: props.selectedMember
                    ? props.selectedMember.override_department_id
                    : false,
                override_split: props.selectedMember
                    ? props.selectedMember.override_split
                    : false,
                split: props.selectedMember ? props.selectedMember.split : "",
                channel: props.selectedMember
                    ? props.selectedMember.channel
                    : false,
                team: props.selectedMember ? props.selectedMember.team : false,
                sub_org: props.selectedMember
                    ? props.selectedMember.sub_org_id
                    : null,
                ems_branch: props.selectedMember
                    ? props.selectedMember.ems_branch
                    : null,
                ems_office: props.selectedMember
                    ? props.selectedMember.ems_office
                    : [],
                ems_rep_id: props.selectedMember
                    ? props.selectedMember.ems_rep_id
                    : null,
                host_signing: props.selectedMember
                    ? props.selectedMember.host_signing
                    : null,
                ems_entity: props.selectedMember
                    ? props.selectedMember.ems_entity
                    : "pc",
                is_v2_enable: props.selectedMember
                    ? props.selectedMember.is_v2_enable
                    : 0,
            },
            is_view_residual: props.selectedMember
                ? props.selectedMember.is_view_residual
                : false,
            is_override: props.selectedMember
                ? props.selectedMember.is_override
                : false,
            channel: props.selectedMember
                ? props.selectedMember.channel
                : false,
            team: props.selectedMember ? props.selectedMember.team : false,
            beta_features: props.selectedMember
                ? props.selectedMember.beta_features == 1
                    ? true
                    : false
                : false,
            is_god_user: props.selectedMember
                ? props.selectedMember.is_god_user == 1
                    ? true
                    : false
                : false,
            bypass_nab: props.selectedMember
                ? props.selectedMember.bypass_nab == 1
                    ? true
                    : false
                : false,
            bypass_ems: props.selectedMember
                ? props.selectedMember.bypass_ems == 1
                    ? true
                    : false
                : false,
            is_notifications_enabled: props.selectedMember
                ? props.selectedMember.is_notifications_enabled == 1
                    ? true
                    : false
                : false,
            override_start_date: props.selectedMember
                ? props.selectedMember.override_start_date
                : null,
            errors: [],
            ValidationErrors: {
                office_id: [],
                branch_id: [],
            },
            formSubmitting: false,
        };
        this.handleAddMember = this.handleAddMember.bind(this);
        this.updateChange = this.updateChange.bind(this);
    }

    handleAddMember(evt) {
        this.setState({ formSubmitting: true });
        let formData = this.state.formData;
        formData["is_view_residual"] = this.state.is_view_residual;
        formData["is_override"] = this.state.is_override;
        formData["channel"] = this.state.channel;
        formData["team"] = this.state.team;
        formData["stratus"] = true;
        formData["beta_features"] = this.state.beta_features;
        formData["is_god_user"] = this.state.is_god_user;
        formData["override_start_date"] = this.state.override_start_date;
        formData["bypass_nab"] = this.state.bypass_nab;
        formData["bypass_ems"] = this.state.bypass_ems;
        formData["is_notifications_enabled"] = this.state.is_notifications_enabled;

        const organization_id = this.props.organization_id;
        if (this.state.isEdit) {
            formData["id"] = this.props.selectedMember.id;
            UpdateMember(organization_id, formData)
                .then((response) => {
                    if (response.success) {
                        this.setState({ formSubmitting: false });
                        this.props.addNewMembers(response.users);
                    } else {
                        this.setState({
                            formSubmitting: false,
                            ValidationErrors: response.errors,
                        });
                    }
                })
                .catch((error) => {
                    this.setState({ formSubmitting: false });
                });
        } else {
            formData["stratus"] = true;
            AddMemberToOrganization(organization_id, formData)
                .then((response) => {
                    if (response.success) {
                        this.setState({ formSubmitting: false });
                        this.props.addNewMembers(response.users);
                    } else {
                        if (response.errors) {
                            let errorMessage = "";
                            Object.entries(response.errors).forEach(
                                ([key, value]) => {
                                    errorMessage =
                                        errorMessage === ""
                                            ? response.errors[key][0]
                                            : errorMessage +
                                              "\n" +
                                              response.errors[key][0];
                                },
                            );
                            alert(errorMessage);
                        } else {
                            alert(response.message);
                        }
                        this.setState({ formSubmitting: false });
                    }
                })
                .catch((error) => {
                    this.setState({ formSubmitting: false });
                });
        }
    }

    updateChange(event) {
        const targetName = event.target.name;
        if (targetName === "") {
            return false;
        }
        let formData = this.state.formData;
        formData[targetName] = event.target.value.trim();
        this.setState({ formData: formData });
    }

    handleZohoChange(event) {
        let formData = this.state.formData;
        formData["zoho_user_id"] = event;
        this.setState({ formData: formData });
    }
    handleOverrideDepartmentChange(event) {
        let formData = this.state.formData;
        formData["override_department_id"] = event;
        this.setState({ formData: formData });
    }
    handleRoleChange(event) {
        let formData = this.state.formData;
        formData["role"] = event.value;
        this.setState({ formData: formData });
    }
    handleTeamChange(event) {
        let formData = this.state.formData;
        formData["team"] = event.value;
        this.setState({ formData: formData, team: event.value });
    }
    handleChannelChange(event) {
        let formData = this.state.formData;
        formData["channel"] = event.value;
        this.setState({ formData: formData, channel: event.value });
    }
    handleAllowedOfficeChange(event) {
        let formData = this.state.formData;
        formData["allowed_offices"] = event;
        this.setState({ formData: formData });
    }
    handleAllowedBranchChange(event) {
        let formData = this.state.formData;
        formData["allowed_branches"] = event;
        this.setState({ formData: formData });
    }
    handleOfficeChange(event) {

        let formData = this.state.formData;
        formData["office_id"] = event;
        this.setState({ formData: formData });
    }
    handleBranchChange(event) {
        let formData = this.state.formData;
        formData["branch_id"] = event;
        this.setState({ formData: formData });
    }

    handleOverrideDepartmentDefaults = () => {
        let DepartmentDefaults = [];
        let formData = this.state.formData;
        if (typeof formData.override_department_id !== "undefined") {
            this.props.departmentList.forEach((item) => {
                if (item.value == formData.override_department_id) {
                    DepartmentDefaults.push(item);
                }
            });
        }
        return DepartmentDefaults;
    };
    handleZohoDefaults = () => {
        let ZohoDefaults = [];
        let formData = this.state.formData;
        if (typeof formData.zoho_user_id !== "undefined") {
            this.props.zohoList.forEach((item2) => {
                if (item2.value == formData.zoho_user_id) {
                    ZohoDefaults.push(item2);
                }
            });
        }
        return ZohoDefaults;
    };
    handleOfficeDefaults = () => {
        return this.state.formData.office_id;
    };

    handleOverrideDateChange = (e) => {
        this.setState({
            override_start_date: e.target.value,
        });
    };

    handleSubOrg = (value) => {
        let formData = this.state.formData;
        formData["sub_org"] = value;
        this.setState({ formData: formData });
    };

    handleHostSigningChange = (value) => {
        let formData = this.state.formData;
        formData["host_signing"] = value;
        this.setState({ formData: formData });
    };

    handleEMSEntityChange = (value) => {
        this.setState({
            formData: {
                ...this.state.formData,
                ems_entity: value,
            },
        });
    };

    handleEmsOffice = (value) => {
        let formData = this.state.formData;
        formData["ems_office"] = value;
        this.setState({ formData: formData });
    };

    handleV2EnableChange = (value) => {
        let formData = this.state.formData;
        formData["is_v2_enable"] = value;
        this.setState({ formData: formData });
    };

    render() {
        const {
            branchesList,
            officesList,
            zohoList,
            userList,
            user,
            departmentList,
        } = this.props;
        const {
            is_submitted,
            addMemberOptions,
            formData,
            errors,
            isEdit,
            ValidationErrors,
        } = this.state;
        let selectedSubOrgTemp = this.props.subOrgs.filter((element) => {
            return element?.id == this.props?.selectedMember?.sub_org_id;
        });
        let selectedSubOrg = {
            value: selectedSubOrgTemp?.id,
            label: selectedSubOrgTemp?.sub_org_name,
        };
        if (selectedSubOrgTemp?.[0]) {
            selectedSubOrg = {
                value: selectedSubOrgTemp?.[0]?.id,
                label: selectedSubOrgTemp?.[0]?.sub_org_name,
            };
        }

        let subOrgSelect = this.props.subOrgs.map((item) => {
            return { label: item.sub_org_name, value: item.id };
        });
        subOrgSelect.unshift({
            label: "None",
            value: null,
        });

        if (this.props?.user?.sub_org_id != null) {
            subOrgSelect = subOrgSelect.filter((item) => {
                return item.value == this.props?.user?.sub_org_id;
            });
            selectedSubOrg = {
                value: subOrgSelect[0]?.value,
                label: subOrgSelect[0]?.label,
            };
        }

        let default_host_signing = { label: "please select", value: "" };
        if (this.state.formData.host_signing !== null) {
            host_signing_options.forEach((item) => {
                if (item.value == this.state.formData.host_signing) {
                    default_host_signing = item;
                }
            });
        }

        let default_ems_entity = { label: "Please Select", value: "" };
        if (this.state.formData.ems_entity !== null) {
            ems_entity_options.forEach((item) => {
                if (item.value == this.state.formData.ems_entity) {
                    default_ems_entity = item;
                }
            });
        }

        let default_is_v2_enable = { label: "No", value: 0 };
        if (this.state.formData.is_v2_enable !== null) {
            is_v2_enable_options.forEach((item) => {
                if (item.value == this.state.formData.is_v2_enable) {
                    default_is_v2_enable = item;
                }
            });
        }

        return (
            <ReactModal
                isOpen={this.props.show}
                className="add-residue-modal Add-residual add-member-modal"
            >
                <div
                    onClick={() => this.props.handleClose()}
                    className="modal-cancel"
                >
                    <img src="/images/cancel.svg" />
                </div>
                <div className="modal-header">
                    <h4 className="text-left">
                        {isEdit ? "Edit member" : "Add member"}
                    </h4>
                </div>
                <div className="modal-body modalscroll">
                    <Formik
                        enableReinitialize
                        validationSchema={schema}
                        onSubmit={(e) => this.handleAddMember(e)}
                        initialValues={formData}
                        initialErrors={errors}
                        validateOnBlur={false}
                        validateOnChange={is_submitted}
                        validate={(values) => {
                            this.setState({ is_submitted: true });
                        }}
                    >
                        {({
                            handleSubmit,
                            handleChange,
                            values,
                            touched,
                            errors,
                        }) => (
                            <Form
                                onSubmit={handleSubmit}
                                onChange={(e) => this.updateChange(e)}
                                autoComplete="off"
                            >
                                <Form.Row>
                                    <Form.Group
                                        as={Col}
                                        xs={12}
                                        className="px-3"
                                    >
                                        <Form.Control
                                            placeholder="First Name"
                                            type="text"
                                            name="first_name"
                                            value={values.first_name}
                                            onChange={handleChange}
                                            isInvalid={
                                                touched.first_name &&
                                                !!errors.first_name
                                            }
                                            isValid={
                                                is_submitted &&
                                                !errors.first_name
                                            }
                                            className="preapp-form-input"
                                        />

                                        <Form.Control.Feedback
                                            type="invalid"
                                            className="text-capitalize"
                                        >
                                            {errors.first_name}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    <Form.Group
                                        as={Col}
                                        xs={12}
                                        className="px-3"
                                    >
                                        <Form.Control
                                            placeholder="Last Name"
                                            type="text"
                                            name="last_name"
                                            value={values.last_name}
                                            onChange={handleChange}
                                            isInvalid={
                                                touched.last_name &&
                                                !!errors.last_name
                                            }
                                            isValid={
                                                is_submitted &&
                                                !errors.last_name
                                            }
                                            className="preapp-form-input"
                                        />
                                        <Form.Control.Feedback
                                            type="invalid"
                                            className="text-capitalize"
                                        >
                                            {errors.last_name}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    <Form.Group
                                        className="px-3 modal-pd"
                                        as={Col}
                                        xs={12}
                                        lg={12}
                                        controlId="role"
                                    >
                                        <SelectDropDown
                                            options={addMemberOptions}
                                            name="role"
                                            placeholder="Select role"
                                            value={values.role}
                                            handleChange={(selected) => {
                                                values.role = selected.value;
                                                this.handleRoleChange(selected);
                                                errors.role = "";
                                            }}
                                            touched={touched.role}
                                            errors={errors.role}
                                            is_submitted={is_submitted}
                                        />
                                        <Form.Control.Feedback
                                            type="invalid"
                                            className="text-capitalize"
                                        >
                                            {errors.role}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    {(isEdit && this.props.isPcAdmin) ===
                                        true ? (
                                        <>
                                        <Form.Group
                                            className="px-12 modal-pd"
                                            as={Col}
                                            xs={12}
                                            lg={12}
                                            controlId="branch"
                                        >
                                            <Select
                                                name="branch"
                                                        value={values.branch_id}
                                                        placeholder="Select Branch"
                                                onChange={(selected) => {
                                                    this.handleBranchChange(selected);
                                                    errors.branch_id = "";
                                                }}
                                                        isMulti={false}
                                                        options={branchesList}
                                                    />
                                                    <Form.Control.Feedback
                                                        type="invalid"
                                                        className="text-capitalize"
                                                    >
                                                        {ValidationErrors.branch_id &&
                                                            ValidationErrors.branch_id.map(
                                                                (error) => {
                                                                    return (
                                                                        <div>
                                                                            {error}
                                                                        </div>
                                                            );
                                                        },
                                                            )}
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                                <Form.Group
                                                    className="px-12 modal-pd"
                                                    as={Col}
                                                    xs={12}
                                                    lg={12}
                                                    controlId="office"
                                                >
                                                    <Select
                                                        name="office"
                                                        placeholder="Select Office"
                                                        value={values.office_id}
                                                        onChange={(selected) => {
                                                            this.handleOfficeChange(selected);
                                                            errors.office_id = "";
                                                        }}
                                                        isMulti={false}
                                                        options={officesList}
                                                    />
                                                    <Form.Control.Feedback
                                                        type="invalid"
                                                        className="text-capitalize"
                                                    >
                                                        {ValidationErrors.office_id &&
                                                            ValidationErrors.office_id.map(
                                                                (error) => {
                                                                    return (
                                                                        <div>
                                                                            {error}
                                                                        </div>
                                                                    );
                                                                },
                                                            )}
                                                    </Form.Control.Feedback>
                                                </Form.Group>


                                                <Form.Group
                                                    className="px-12 modal-pd"
                                                    as={Col}
                                                    xs={12}
                                                    lg={12}
                                                    controlId="allowed_offices"
                                                >
                                                    <Select
                                                        name="allowed_offices"
                                                        value={values.allowed_offices}
                                                        placeholder="Select Allowed Offices"
                                                        onChange={(selected) => {
                                                            this.handleAllowedOfficeChange(selected);
                                                            errors.allowed_offices = "";
                                                        }}
                                                        isMulti={true}
                                                        options={officesList}
                                                    />
                                                    <Form.Control.Feedback
                                                        type="invalid"
                                                        className="text-capitalize"
                                                    >
                                                        {ValidationErrors.allowed_offices &&
                                                            ValidationErrors.allowed_offices.map(
                                                                (error) => {
                                                                    return (
                                                                        <div>
                                                                            {error}
                                                                        </div>
                                                                    );
                                                                },
                                                            )}
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                                <Form.Group
                                                    className="px-12 modal-pd"
                                                    as={Col}
                                                    xs={12}
                                                    lg={12}
                                                    controlId="allowed_branches"
                                                >
                                                    <Select
                                                        name="allowed_branches"
                                                        placeholder="Select Allowed Branches"
                                                        value={values.allowed_branches}
                                                        onChange={(selected) => {
                                                            this.handleAllowedBranchChange(selected);
                                                            errors.allowed_branches = "";
                                                        }}
                                                        isMulti={true}
                                                        options={branchesList}
                                                    />
                                                    <Form.Control.Feedback
                                                        type="invalid"
                                                        className="text-capitalize"
                                                    >
                                                        {ValidationErrors.allowed_branches &&
                                                            ValidationErrors.allowed_branches.map(
                                                                (error) => {
                                                                    return (
                                                                        <div>
                                                                            {error}
                                                                        </div>
                                                                    );
                                                                },
                                                            )}
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                        </>
                                    ) : <></>}
                                    <Form.Group
                                        as={Col}
                                        xs={12}
                                        className="px-3"
                                    >
                                        <Cleave
                                            options={{
                                                blocks: [3, 3, 4],
                                                delimiter: "-",
                                                numericOnly: true,
                                            }}
                                            placeholder="Direct phone"
                                            name="phone_direct"
                                            value={values.phone_direct}
                                            onChange={handleChange}
                                            type="text"
                                            className={`preapp-form-input form-control ${
                                                is_submitted &&
                                                !errors.phone_direct &&
                                                "is-valid"
                                            } ${
                                                touched.phone_direct &&
                                                !!errors.phone_direct &&
                                                "is-invalid"
                                            }`}
                                        />

                                        <Form.Control.Feedback
                                            type="invalid"
                                            className="text-capitalize"
                                        >
                                            {errors.phone_direct}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    <Form.Group
                                        as={Col}
                                        xs={12}
                                        className="px-3"
                                    >
                                        <Cleave
                                            options={{
                                                blocks: [3, 3, 4],
                                                delimiter: "-",
                                                numericOnly: true,
                                            }}
                                            placeholder="Cell phone"
                                            name="phone_cell"
                                            value={values.phone_cell}
                                            onChange={handleChange}
                                            type="text"
                                            className={`preapp-form-input form-control ${
                                                is_submitted &&
                                                !errors.phone_direct &&
                                                "is-valid"
                                            } ${
                                                touched.phone_cell &&
                                                !!errors.phone_cell &&
                                                "is-invalid"
                                            }`}
                                        />

                                        <Form.Control.Feedback
                                            type="invalid"
                                            className="text-capitalize"
                                        >
                                            {errors.phone_cell}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    <Form.Group
                                        as={Col}
                                        xs={12}
                                        className="px-3"
                                    >
                                        <Form.Control
                                            placeholder="Address"
                                            type="text"
                                            name="address"
                                            value={values.address}
                                            onChange={handleChange}
                                            isInvalid={
                                                touched.name && !!errors.address
                                            }
                                            isValid={
                                                is_submitted && !errors.address
                                            }
                                            className="preapp-form-input"
                                        />

                                        <Form.Control.Feedback
                                            type="invalid"
                                            className="text-capitalize"
                                        >
                                            {errors.address}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group
                                        as={Col}
                                        xs={12}
                                        className="px-3"
                                    >
                                        <Form.Control
                                            placeholder="Email"
                                            type="text"
                                            name="email"
                                            value={values.email}
                                            onChange={handleChange}
                                            isInvalid={
                                                touched.name && !!errors.email
                                            }
                                            isValid={
                                                is_submitted && !errors.email
                                            }
                                            className="preapp-form-input"
                                        />

                                        <Form.Control.Feedback
                                            type="invalid"
                                            className="text-capitalize"
                                        >
                                            {errors.email}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    {this.props.isPcAdmin ? (
                                        <>
                                            <Form.Group
                                                as={Col}
                                                xs={12}
                                                className="px-3"
                                            >
                                                <SelectDropDown
                                                    options={UserChannel}
                                                    name="channel"
                                                    placeholder="Select Channel"
                                                    value={values.channel}
                                                    handleChange={(
                                                        selected,
                                                    ) => {
                                                        values.channel =
                                                            selected.value;
                                                        this.handleChannelChange(
                                                            selected,
                                                        );
                                                        errors.channel = "";
                                                    }}
                                                    touched={touched.channel}
                                                    errors={errors.channel}
                                                    is_submitted={is_submitted}
                                                />
                                                <Form.Control.Feedback
                                                    type="invalid"
                                                    className="text-capitalize"
                                                ></Form.Control.Feedback>
                                            </Form.Group>

                                            <Form.Group
                                                as={Col}
                                                xs={12}
                                                className="px-3"
                                            >
                                                <SelectDropDown
                                                    options={Team}
                                                    name="team"
                                                    placeholder="Select team"
                                                    value={values.team}
                                                    handleChange={(
                                                        selected,
                                                    ) => {
                                                        values.team =
                                                            selected.value;
                                                        this.handleTeamChange(
                                                            selected,
                                                        );
                                                        errors.team = "";
                                                    }}
                                                    touched={touched.team}
                                                    errors={errors.team}
                                                    is_submitted={is_submitted}
                                                />
                                                <Form.Control.Feedback
                                                    type="invalid"
                                                    className="text-capitalize"
                                                ></Form.Control.Feedback>
                                            </Form.Group>
                                        </>
                                    ) : (
                                        <></>
                                    )}
                                    <Form.Group
                                        as={Col}
                                        xs={12}
                                        className="px-3"
                                    >
                                        <div className="form-check form-check-inline">
                                            <input
                                                type="checkbox"
                                                id="is_view_residual"
                                                className="form-check-input"
                                                name="is_view_residual"
                                                defaultChecked={
                                                    this.state.is_view_residual
                                                }
                                                value={
                                                    this.state.is_view_residual
                                                }
                                                onChange={(handleChange) => {
                                                    this.setState({
                                                        is_view_residual:
                                                            !this.state
                                                                .is_view_residual,
                                                    });
                                                }}
                                            />
                                            <label
                                                htmlFor="web-checkout"
                                                className="form-check-label"
                                            >
                                                <span className="preapp-checkbox" />
                                                View Organization Residuals?
                                            </label>
                                        </div>
                                    </Form.Group>
                                    {(isEdit && this.props.isPcAdmin) ===
                                        true && (
                                        <>
                                            <Form.Group
                                            as={Col}
                                            xs={12}
                                            className="px-3"
                                        >
                                            <div className="form-check form-check-inline">
                                                <input
                                                    type="checkbox"
                                                    id="beta_features"
                                                    className="form-check-input"
                                                    name="beta_features"
                                                    defaultChecked={
                                                        this.state.beta_features
                                                    }
                                                    value={
                                                        this.state.beta_features
                                                    }
                                                    onChange={(
                                                        handleChange,
                                                    ) => {
                                                        this.setState({
                                                            beta_features:
                                                                !this.state
                                                                    .beta_features,
                                                        });
                                                    }}
                                                />
                                                <label
                                                    htmlFor="beta_features"
                                                    className="form-check-label"
                                                >
                                                    <span className="preapp-checkbox" />
                                                    Beta Features
                                                </label>
                                            </div>
                                            </Form.Group>
                                            {this.props?.selectedMember?.organization_id == 1 && <Form.Group
                                                as={Col}
                                                xs={12}
                                                className="px-3"
                                            >
                                                <div className="form-check form-check-inline">
                                                    <input
                                                        type="checkbox"
                                                        id="is_god_user"
                                                        className="form-check-input"
                                                        name="is_god_user"
                                                        defaultChecked={
                                                            this.state.is_god_user
                                                        }
                                                        value={
                                                            this.state.is_god_user
                                                        }
                                                        onChange={(
                                                            handleChange,
                                                        ) => {
                                                            this.setState({
                                                                is_god_user:
                                                                    !this.state
                                                                        .is_god_user,
                                                            });
                                                        }}
                                                    />
                                                    <label
                                                        htmlFor="is_god_user"
                                                        className="form-check-label"
                                                    >
                                                        <span className="preapp-checkbox" />
                                                        God User
                                                    </label>
                                                </div>
                                            </Form.Group>}

                                        </>
                                    )}

                                    {(isEdit && this.props.isPcAdmin) ===
                                        true && (
                                        <div>
                                            <Form.Group
                                                as={Col}
                                                xs={12}
                                                className="px-3"
                                            >
                                                <div className="form-check form-check-inline">
                                                    <input
                                                        type="checkbox"
                                                        id="bypass_nab"
                                                        className="form-check-input"
                                                        name="bypass_nab"
                                                        defaultChecked={
                                                            this.state
                                                                .bypass_nab
                                                        }
                                                        value={
                                                            this.state
                                                                .bypass_nab
                                                        }
                                                        onChange={(
                                                            handleChange,
                                                        ) => {
                                                            this.setState({
                                                                bypass_nab:
                                                                    !this.state
                                                                        .bypass_nab,
                                                            });
                                                        }}
                                                    />
                                                    <label
                                                        htmlFor="bypass_nab"
                                                        className="form-check-label"
                                                    >
                                                        <span className="preapp-checkbox" />
                                                        Bypass NAB
                                                    </label>
                                                </div>
                                            </Form.Group>
                                            <Form.Group
                                                as={Col}
                                                xs={12}
                                                className="px-3"
                                            >
                                                <div className="form-check form-check-inline">
                                                    <input
                                                        type="checkbox"
                                                        id="bypass_ems"
                                                        className="form-check-input"
                                                        name="bypass_ems"
                                                        defaultChecked={
                                                            this.state
                                                                .bypass_ems
                                                        }
                                                        value={
                                                            this.state
                                                                .bypass_ems
                                                        }
                                                        onChange={(
                                                            handleChange,
                                                        ) => {
                                                            this.setState({
                                                                bypass_ems:
                                                                    !this.state
                                                                        .bypass_ems,
                                                            });
                                                        }}
                                                    />
                                                    <label
                                                        htmlFor="bypass_ems"
                                                        className="form-check-label"
                                                    >
                                                        <span className="preapp-checkbox" />{" "}
                                                        Bypass EMS
                                                    </label>
                                                </div>
                                            </Form.Group>
                                            <Form.Group
                                                as={Col}
                                                xs={12}
                                                className="px-3"
                                            >
                                                <div className="form-check form-check-inline">
                                                    <input
                                                        type="checkbox"
                                                        id="is_notifications_enabled"
                                                        className="form-check-input"
                                                        name="is_notifications_enabled"
                                                        defaultChecked={
                                                            this.state
                                                                .is_notifications_enabled
                                                        }
                                                        value={
                                                            this.state
                                                                .is_notifications_enabled
                                                        }
                                                        onChange={(
                                                            handleChange,
                                                        ) => {
                                                            this.setState({
                                                                is_notifications_enabled:
                                                                    !this.state
                                                                        .is_notifications_enabled,
                                                            });
                                                        }}
                                                    />
                                                    <label
                                                        htmlFor="is_notifications_enabled"
                                                        className="form-check-label"
                                                    >
                                                        <span className="preapp-checkbox" />{" "}
                                                        Notifications Enabled
                                                    </label>
                                                </div>
                                            </Form.Group>
                                        </div>
                                    )}

                                    {isEdit &&
                                    this.props.organization_id == 1 ? (
                                        <div>
                                            <>
                                                <Form.Group
                                                    as={Col}
                                                    xs={12}
                                                    className="px-3"
                                                >
                                                    <Select
                                                        name="zoho_user"
                                                        placeholder="Select Zoho User"
                                                        defaultValue={this.handleZohoDefaults()}
                                                        onChange={(
                                                            selected,
                                                        ) => {
                                                            this.handleZohoChange(
                                                                selected.value,
                                                            );
                                                        }}
                                                        isMulti={false}
                                                        options={zohoList}
                                                    />
                                                    <Form.Control.Feedback
                                                        type="invalid"
                                                        className="text-capitalize"
                                                    >
                                                        {ValidationErrors.zoho_user_id &&
                                                            ValidationErrors.zoho_user_id.map(
                                                                (error) => {
                                                                    return (
                                                                        <div>
                                                                            {
                                                                                error
                                                                            }
                                                                        </div>
                                                                    );
                                                                },
                                                            )}
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </>
                                            {user != null &&
                                            user.id &&
                                            config.paymentcloud
                                                .RESIDUAL_SYSTEM &&
                                            config.paymentcloud.RESIDUAL_SYSTEM.includes(
                                                user.id,
                                            ) ? (
                                                <>
                                                    <Form.Group
                                                        as={Col}
                                                        xs={12}
                                                        className="px-3"
                                                    >
                                                        <Form.Control
                                                            placeholder="Split"
                                                            type="text"
                                                            name="split"
                                                            value={values.split}
                                                            onChange={
                                                                handleChange
                                                            }
                                                            isInvalid={
                                                                touched.split &&
                                                                !!errors.split
                                                            }
                                                            isValid={
                                                                is_submitted &&
                                                                !errors.split
                                                            }
                                                            className="preapp-form-input"
                                                        />

                                                        <Form.Control.Feedback
                                                            type="invalid"
                                                            className="text-capitalize"
                                                        >
                                                            {errors.split}
                                                        </Form.Control.Feedback>
                                                    </Form.Group>
                                                    <Form.Group
                                                        as={Col}
                                                        xs={12}
                                                        className="px-3"
                                                    >
                                                        <input
                                                            type="checkbox"
                                                            id="is_override"
                                                            className="form-check-input"
                                                            name="is_override"
                                                            defaultChecked={
                                                                this.state
                                                                    .is_override
                                                            }
                                                            value={
                                                                this.state
                                                                    .is_override
                                                            }
                                                            onChange={(
                                                                handleChange,
                                                            ) => {
                                                                this.setState({
                                                                    is_override:
                                                                        !this
                                                                            .state
                                                                            .is_override,
                                                                });
                                                            }}
                                                        />
                                                        <label
                                                            htmlFor="web-checkout"
                                                            className="form-check-label"
                                                        >
                                                            <span className="preapp-checkbox" />
                                                            Is Override
                                                        </label>
                                                    </Form.Group>
                                                    {this.state.is_override ? (
                                                        <div>
                                                            <Form.Group
                                                                as={Col}
                                                                xs={12}
                                                                className="px-3"
                                                            >
                                                                <Form.Control
                                                                    placeholder="Override Split"
                                                                    type="text"
                                                                    name="override_split"
                                                                    value={
                                                                        values.override_split
                                                                    }
                                                                    onChange={
                                                                        handleChange
                                                                    }
                                                                    isInvalid={
                                                                        touched.override_split &&
                                                                        !!errors.override_split
                                                                    }
                                                                    isValid={
                                                                        is_submitted &&
                                                                        !errors.override_split
                                                                    }
                                                                    className="preapp-form-input"
                                                                />
                                                                <Form.Control.Feedback
                                                                    type="invalid"
                                                                    className="text-capitalize"
                                                                >
                                                                    {
                                                                        errors.override_split
                                                                    }
                                                                </Form.Control.Feedback>
                                                            </Form.Group>
                                                        </div>
                                                    ) : null}
                                                    {this.state.is_override ? (
                                                        <div>
                                                            <>
                                                                <Form.Group
                                                                    as={Col}
                                                                    xs={12}
                                                                    className="px-3"
                                                                >
                                                                    <Select
                                                                        name="override_department_id"
                                                                        placeholder="Override Department"
                                                                        defaultValue={this.handleOverrideDepartmentDefaults()}
                                                                        onChange={(
                                                                            selected,
                                                                        ) => {
                                                                            this.handleOverrideDepartmentChange(
                                                                                selected.value,
                                                                            );
                                                                        }}
                                                                        isMulti={
                                                                            false
                                                                        }
                                                                        options={
                                                                            departmentList
                                                                        }
                                                                    />
                                                                    <Form.Control.Feedback
                                                                        type="invalid"
                                                                        className="text-capitalize"
                                                                    >
                                                                        {ValidationErrors.override_department_id &&
                                                                            ValidationErrors.override_department_id.map(
                                                                                (
                                                                                    error,
                                                                                ) => {
                                                                                    return (
                                                                                        <div>
                                                                                            {
                                                                                                error
                                                                                            }
                                                                                        </div>
                                                                                    );
                                                                                },
                                                                            )}
                                                                    </Form.Control.Feedback>
                                                                </Form.Group>
                                                            </>
                                                        </div>
                                                    ) : null}
                                                    {this.state.is_override ? (
                                                        <div>
                                                            <>
                                                                <Form.Group
                                                                    as={Col}
                                                                    xs={12}
                                                                    className="px-3"
                                                                >
                                                                    <label>
                                                                        Override
                                                                        Start
                                                                        Date
                                                                    </label>
                                                                    <Form.Control
                                                                        type="date"
                                                                        className="preapp-form-input"
                                                                        required={
                                                                            true
                                                                        }
                                                                        value={
                                                                            this
                                                                                .state
                                                                                .override_start_date
                                                                        }
                                                                        onChange={(
                                                                            e,
                                                                        ) =>
                                                                            this.handleOverrideDateChange(
                                                                                e,
                                                                            )
                                                                        }
                                                                        name="override_start_date"
                                                                    />
                                                                    <Form.Control.Feedback
                                                                        type="invalid"
                                                                        className="text-capitalize"
                                                                    ></Form.Control.Feedback>
                                                                </Form.Group>
                                                            </>
                                                        </div>
                                                    ) : null}
                                                </>
                                            ) : null}
                                        </div>
                                    ) : null}
                                    {isEdit &&
                                    (this.props.isPcAdmin === true ||
                                        this.props?.user?.is_ems_pc_admin ==
                                            true) ? (
                                        <>
                                            <Form.Group
                                                as={Col}
                                                xs={12}
                                                className="px-3"
                                            >
                                                <Cleave
                                                    options={{
                                                        blocks: [3, 3],
                                                        numericOnly: true,
                                                    }}
                                                    placeholder="EMS Branch"
                                                    name="ems_branch"
                                                    value={values.ems_branch}
                                                    onChange={handleChange}
                                                    type="text"
                                                    className={`preapp-form-input form-control ${
                                                        is_submitted &&
                                                        !errors.ems_branch &&
                                                        "is-valid"
                                                    } ${
                                                        touched.ems_branch &&
                                                        !!errors.ems_branch &&
                                                        "is-invalid"
                                                    }`}
                                                />

                                                <Form.Control.Feedback
                                                    type="invalid"
                                                    className="text-capitalize"
                                                >
                                                    {errors.ems_branch}
                                                </Form.Control.Feedback>
                                            </Form.Group>

                                            <Form.Group
                                                as={Col}
                                                xs={12}
                                                className="px-3"
                                            >
                                                <Select
                                                    name="ems_office"
                                                    placeholder="EMS Office"
                                                    defaultValue={
                                                        values.ems_office
                                                    }
                                                    onChange={(selected) => {
                                                        this.handleEmsOffice(
                                                            selected,
                                                        );
                                                    }}
                                                    isMulti
                                                    options={
                                                        this.props.emsOffices
                                                    }
                                                />

                                                <Form.Control.Feedback
                                                    type="invalid"
                                                    className="text-capitalize"
                                                >
                                                    {errors.ems_office}
                                                </Form.Control.Feedback>
                                            </Form.Group>

                                            <Form.Group
                                                as={Col}
                                                xs={12}
                                                className="px-3"
                                            >
                                                <Cleave
                                                    options={{
                                                        blocks: [3, 3],
                                                        numericOnly: true,
                                                    }}
                                                    placeholder="EMS Rep Id"
                                                    name="ems_rep_id"
                                                    value={values.ems_rep_id}
                                                    onChange={handleChange}
                                                    type="text"
                                                    className={`preapp-form-input form-control ${
                                                        is_submitted &&
                                                        !errors.ems_rep_id &&
                                                        "is-valid"
                                                    } ${
                                                        touched.ems_rep_id &&
                                                        !!errors.ems_rep_id &&
                                                        "is-invalid"
                                                    }`}
                                                />

                                                <Form.Control.Feedback
                                                    type="invalid"
                                                    className="text-capitalize"
                                                >
                                                    {errors.ems_rep_id}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </>
                                    ) : (
                                        <></>
                                    )}

                                    {this.props?.user?.role == "admin" ? (
                                        <Form.Group
                                            as={Col}
                                            xs={12}
                                            className="px-3"
                                        >
                                            <Form.Label>
                                                Select Sub Organization
                                            </Form.Label>
                                            <Select
                                                name="sub_org"
                                                placeholder="Select Sub Organization"
                                                defaultValue={selectedSubOrg}
                                                onChange={(selected) => {
                                                    this.handleSubOrg(
                                                        selected.value,
                                                    );
                                                }}
                                                isMulti={false}
                                                options={subOrgSelect}
                                            />
                                            <Form.Control.Feedback
                                                type="invalid"
                                                className="text-capitalize"
                                            >
                                                {ValidationErrors.sub_org &&
                                                    ValidationErrors.sub_org.map(
                                                        (error) => {
                                                            return (
                                                                <div>
                                                                    {error}
                                                                </div>
                                                            );
                                                        },
                                                    )}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    ) : (
                                        ""
                                    )}

                                    <Form.Group
                                        as={Col}
                                        xs={12}
                                        className="px-3"
                                    >
                                        <Form.Label>Host Signing</Form.Label>
                                        <Select
                                            name="host_signing"
                                            placeholder="Host Signing"
                                            defaultValue={default_host_signing}
                                            onChange={(selected) => {
                                                this.handleHostSigningChange(
                                                    selected.value,
                                                );
                                            }}
                                            isMulti={false}
                                            options={host_signing_options}
                                        />
                                        <Form.Control.Feedback
                                            type="invalid"
                                            className="text-capitalize"
                                        >
                                            {ValidationErrors.sub_org &&
                                                ValidationErrors.sub_org.map(
                                                    (error) => {
                                                        return (
                                                            <div>{error}</div>
                                                        );
                                                    },
                                                )}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group
                                        as={Col}
                                        xs={12}
                                        className="px-3"
                                    >
                                        <Form.Label>Entity</Form.Label>
                                        <Select
                                            name="ems_entity"
                                            placeholder="EMS entity"
                                            defaultValue={default_ems_entity}
                                            onChange={(selected) => {
                                                this.handleEMSEntityChange(
                                                    selected.value,
                                                );
                                            }}
                                            isMulti={false}
                                            options={ems_entity_options}
                                        />
                                        <Form.Control.Feedback
                                            type="invalid"
                                            className="text-capitalize"
                                        >
                                            {ValidationErrors.ems_entity &&
                                                ValidationErrors.ems_entity.map(
                                                    (error) => {
                                                        return (
                                                            <div>{error}</div>
                                                        );
                                                    },
                                                )}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                            
                                  {this.props.isPcAdmin ? (
                                    <Form.Group
                                        as={Col}
                                        xs={12}
                                        className="px-3"
                                    >
                                        <Form.Label>V2 Enable</Form.Label>
                                        <Select
                                            name="is_v2_enable"
                                            placeholder="V2 Enable"
                                            defaultValue={default_is_v2_enable}
                                            onChange={(selected) => {
                                                this.handleV2EnableChange(
                                                    selected.value,
                                                );
                                            }}
                                            isMulti={false}
                                            options={is_v2_enable_options}
                                        />
                                        <Form.Control.Feedback
                                            type="invalid"
                                            className="text-capitalize"
                                        >
                                            {ValidationErrors.is_v2_enable &&
                                                ValidationErrors.is_v2_enable.map(
                                                    (error) => {
                                                        return (
                                                            <div>{error}</div>
                                                        );
                                                    },
                                                )}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    ) : <></>}
                                </Form.Row>
                                <div className="modal-footer">
                                    <button
                                        disabled={this.state.formSubmitting}
                                        type="submit"
                                        className="btn confirm-button"
                                    >
                                        {isEdit ? "Update" : "Add"}
                                    </button>
                                    <button
                                        className="btn cancel-button"
                                        onClick={() => this.props.handleClose()}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </div>
            </ReactModal>
        );
    }
}

export default AddMembermodal;
